<!--
    @name   AppLoading
    @desc   加载组件
    @props
            type        emun['page']         loading类型['page','data','list']
-->
<template>
  <div v-if="type === 'data'" class="app-loading-wrapper data">
    <div class="data-loading">
      <img src="../../../static/img/loading.svg" alt="" style="width:100px;">
    </div>
  </div>
  <div v-else-if="type === 'list'" class="app-loading-wrapper moreList">
    <!--<div class="list-loading">-->
      <!--<div></div>-->
    <!--</div>-->
    <img src="../../../static/img/loading.svg" alt="" style="width:100px;">
  </div>
  <div v-else-if="type === 'index_list'" class="app-loading-wrapper list">
    <img src="../../../static/img/loading.svg" alt="" style="width:100px;">
  </div>
  <div v-else class="app-loading-wrapper page" :style="{height:windowHeight+'px'}">
    <img src="../../../static/img/loading.svg" alt="" style="width:100px;">
  </div>
</template>

<script>
export default {
  name: 'AppLoading',
  props: ['type'],
  data(){
    return{
      windowHeight:null
    }
  },
  mounted() {
    this.windowHeight = document.documentElement.clientHeight
  }
}
</script>

<style lang="scss" scoped>
.app-loading-wrapper {
  &.moreList {
    display: flex;
    padding-bottom: 20px;
    font-size: 22px;
    /*background: #fff;*/
    align-items: center;
    justify-content: center;
  }
  &.data {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10001;
    position: fixed;
    background: rgba(0, 0, 0, .2);
  }
  &.page {
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    position: absolute;
    /*background: #fff;*/
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.data-loading {
  top: 50%;
  left: 50%;
  width: 120px;
  height: 120px;
  display: flex;
  position: fixed;
  align-items: center;
  border-radius: 50%;
  justify-content: center;
  transform: translate(-50%, -50%);
  background: #fff;
  .data-loading-border {
    width: 50px;
    height: 50px;
    padding: 3px;
    display: flex;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.1) 33%,
      rgba(255, 255, 255, 1) 100%
    );
    animation: spin 1.2s linear 0s infinite;
  }
  .data-loading-core {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #2f2f2f;
  }
}
.list-loading {
  margin: 2px;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: inline-block;
  animation-fill-mode: both;
  border: 4px solid #4388e1;
  border-bottom-color: transparent;
  background: transparent !important;
  animation: rotate 0.75s 0s linear infinite;
}
.page-loading {
  top: 50%;
  left: 50%;
  color: #000;
  position: absolute;
  transform: translate(-50%, -50%);
}
@keyframes spin {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(359deg);
  }
}
@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-webkit-keyframes pacman-balls {
  75% {
    opacity: 0.7;
  }

  100% {
    -webkit-transform: translate(-100px, -6.25px);
    transform: translate(-100px, -6.25px);
  }
}

@keyframes pacman-balls {
  75% {
    opacity: 0.7;
  }

  100% {
    -webkit-transform: translate(-100px, -6.25px);
    transform: translate(-100px, -6.25px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppLoading/AppLoading.vue